import { Link } from "react-router-dom";
import styled from "styled-components";

// Styled components mapping previous Tailwind styles
export const CenterScreen = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none; /* allow underlying modal to receive events when open */
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  top: 39px; /* Exactly under UpperNav height */
  opacity: 0.7;
  background: #1c473b;
  z-index: 100000;

  @media (max-width: 768px) {
    top: 0; /* No UpperNav on mobile */
  }
`;

export const ScrollRegion = styled.div`
  position: fixed;
  inset: 0;
  top: 39px; /* Exactly under UpperNav height */
  overflow-y: auto;
  z-index: 100001;
  @media (max-width: 768px) {
    top: 0; /* No UpperNav on mobile */
  }
`;

export const Panel = styled.div`
  width: 100%;
  background-color: white;
`;

export const SearchWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SearchHeader = styled.div`
  display: flex;
  justify-items: stretch;
  padding: 12px 36px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.3);
  @media (max-width: 768px) {
    padding: 16px 18px;
    gap: 12;
  }
`;

export const InputWrapper = styled.div`
  flex-grow: 1;
  position: relative;
  margin-right: 24px;
  margin-left: 33px;
  @media (max-width: 768px) {
    margin: 0;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 100%;
  padding-left: 90px;
  padding-right: 24px;
  border-left: 1px solid rgba(0, 0, 0, 0.14);
  border-right: 1px solid rgba(0, 0, 0, 0.14);
  outline: none;
  color: #111;
  font-family: ${({ theme }) => theme.fonts.ivy};
  font-size: 25px;
  font-style: normal;
  font-weight: 400;
  line-height: 110%; /* 27.5px */
  &:focus {
    outline: none;
    box-shadow: none;
  }
  @media (max-width: 768px) {
    padding-left: 16px; /* remove icon space on mobile */
    font-size: 18px;
    border: none;
  }
`;

export const ClearBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 24px;
  height: 24px;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  color: #1c473b;
  outline: none;
  border: none;
  background: transparent;
  cursor: pointer;
`;

export const SearchIconContainer = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 24px;
  height: 24px;
  left: 33px;
  top: 50%;
  transform: translateY(-50%);
  @media (max-width: 768px) {
    display: none; /* hide icon on mobile */
  }
`;

export const CloseButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 46px;
  height: 46px;
  background: #f5f5f5;
  color: black;
  flex-shrink: 0;
  outline: none;
  border: none;
  cursor: pointer;
`;

export const FilterBtn = styled.button`
  display: flex;
  padding: 15px 32px;
  align-items: center;
  gap: 7px;
  border: 1px solid #000;
  background: ${(props) => (props.active ? "#307361" : "#F5F5F5")};
  color: ${(props) => (props.active ? "#fff" : "#111")};
  outline: none;
  cursor: pointer;
  font-family: ${({ theme }) => theme.fonts.ivy};
  @media (max-width: 768px) {
    width: 36px;
    height: 36px;
    padding: 0;
    border: none;
    justify-content: center;
    position: relative;

    .filter-count {
      display: none;
    }

    .filter-label {
      display: none;
    }

    .filter-notification-dot {
      display: flex;
      position: absolute;
      top: 4px;
      right: 4px;
      background: #1c473b;
      background-color: #f22253;

      width: 8px;
      height: 8px;
      border-radius: 100%;
      align-items: center;
      justify-content: center;
    }
  }
`;

export const Grid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
`;

// Search Results
export const ResultsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: calc(700px - 73px);
  overflow-y: scroll;
`;

export const ResultsList = styled.ul`
  width: 100%;
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const ResultItem = styled.li`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 148px;
  align-items: center;

  &:hover {
    background: #f5f5f5;
  }

  @media (max-width: 768px) {
    padding: 14px 16px;
  }
`;

export const ResultMain = styled.span`
  color: #111;
  font-family: ${({ theme }) => theme.fonts.sofia};
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 140%; /* 19.6px */
`;

export const ResultTag = styled.span`
  display: flex;
  padding: 4px 12px;
  align-items: center;
  gap: 2px;
  border-radius: 55px;
  border: 1px solid #929292;
  color: #929292;
  font-family: ${({ theme }) => theme.fonts.sofia};
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 140%; /* 19.6px */
`;

export const EmptyResults = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
  padding: 16px;
  justify-content: center;
  align-items: center;
  color: #111;
  font-family: ${({ theme }) => theme.fonts.sofia};
  font-style: normal;
  h1 {
    text-align: center;
    font-size: 40px;
    font-weight: 300;
    line-height: 140%; /* 56px */
  }

  h2 {
    margin-top: 8px;
    font-size: 24px;
    font-weight: 300;
    line-height: 140%; /* 33.6px */
  }

  span {
    width: 243px;
    height: 243px;
  }
`;

export const SearchInitialStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-items: start;
  gap: 28px;
  padding: 0px 148px;
  height: calc(700px - 73px);
  @media (max-width: 768px) {
    padding-left: 16px;
    padding-right: 0px;
    gap: 24px;
    height: unset;
  }
`;

export const SectionWrapper = styled.section`
  display: flex;
  flex-direction: column;
  justify-items: start;
  gap: 20px;
  padding-bottom: 28px;
  &:first-child {
    border-bottom: 1px solid #cecece;
  }
  @media (max-width: 768px) {
    gap: 12px;
    padding-bottom: 20px;
  }
`;

export const Title = styled.h2`
  color: #1c473b;
  font-family: ${({ theme }) => theme.fonts.ivy};
  font-size: 25px;
  font-style: normal;
  font-weight: 400;
  line-height: 110%; /* 27.5px */
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const TagsWrapper = styled.div`
  display: flex;

  gap: 8px;
`;

export const Tag = styled.div`
  cursor: pointer;
  display: flex;
  padding: 4px 12px;
  align-items: center;
  justify-items: center;
  gap: 4px;
  border-radius: 55px;
  background: #d0ebe4;
  color: #111;
  text-align: center;
  vertical-align: center;

  p {
    font-family: ${({ theme }) => theme.fonts.sofia};
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 140%; /* 19.6px */
  }

  span {
    font-size: 10px;
    flex-shrink: 0;
  }
  @media (max-width: 768px) {
    padding: 4px 12px;
    font-weight: 300;
  }
`;

export const ForYouGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
  @media (max-width: 768px) {
    display: none; /* hidden when swiper used */
  }
`;

export const ForYouCard = styled.div`
  position: relative;
  height: 416px;
  @media (max-width: 768px) {
    height: 360px;
  }
`;

export const ForYouCardContent = styled(Link)`
  position: absolute;
  inset: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 6px;
  padding: 0 16px;
  padding-top: 18px;
  padding-bottom: 30px;
  text-align: center;
  padding-left: 12px;
  padding-right: 12px;
`;

export const ForYouCardImage = styled.img`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ForYouCardShadow = styled.span`
  position: absolute;
  z-index: 20;
  left: 0;
  right: 0;
  bottom: 0;
  height: 76px;
  opacity: 0.5;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
`;

export const CardTitle = styled.span`
  color: white;
  font-family: ${({ theme }) => theme.fonts.ivy};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 110%; /* 17.6px */
`;

export const FavBtn = styled.button`
  display: flex;
  border-radius: 100%;
  background-color: white;
  width: 34px;
  height: 34px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  outline: none;
  border: none;
  cursor: pointer;
  @media (max-width: 768px) {
    width: 22px;
    height: 22px;
  }
`;

// Filters side panel (inside search)
export const FiltersPanelWrapper = styled.aside`
  position: absolute;
  top: 0;
  right: 0;
  width: 612px;
  height: calc(100% - 14px);
  display: flex;
  flex-direction: column;
  padding: 24px 28px;
  background: #ffffff;
  border-left: 1px solid #cecece;
  background: #fff;
  box-shadow: -21px 4px 49.4px 0 rgba(0, 0, 0, 0.25);
  z-index: 100010; /* above search header */
  @media (max-width: 768px) {
    width: 100%;
    position: fixed;
    inset: 0;
    top: 79px; /* below search bar */
    height: 80vh;
    box-shadow: none;
  }
`;

export const FiltersPanelHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 32px;
  border-bottom: 1px solid #cecece;
  color: #1c473b;
  font-family: ${({ theme }) => theme.fonts.ivy};
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 110%; /* 35.2px */

  @media (max-width: 768px) {
    padding-bottom: 0;
    border: none;
    font-weight: 400;
    font-size: 20px;
    line-height: 110.00000000000001%;
    letter-spacing: 0%;
    vertical-align: middle;
  }
`;

export const CloseXBtn = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 32px;
  line-height: 1;
  color: black;
  outline: none;
  @media (max-width: 768px) {
    display: none;
  }
`;

export const FiltersPanelBody = styled.div`
  overflow-y: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const FiltersSection = styled.section`
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  gap: 16px;

  h3 {
    color: #1c473b;
    font-family: ${({ theme }) => theme.fonts.ivy};
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 110%; /* 27.5px */

    @media (max-width: 768px) {
      font-size: 16px;
      line-height: 110%;
      letter-spacing: 0%;
      vertical-align: middle;
    }
  }

  &:first-child {
    border-bottom: 1px solid #cecece;
  }
`;

export const FilterChipsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const FilterChip = styled.button`
  border: 1px solid ${(p) => (p.$active ? "#307361" : "##E7E8E8")};
  background: ${(p) => (p.$active ? "#D0EBE4" : "#E7E8E8")};
  color: ${(p) => (p.$active ? "#307361" : "#111")};
  padding: 6px 12px;
  border-radius: 40px;
  display: flex;
  padding: 11px 29px;
  align-items: center;
  gap: 2px;
  transition: background 0.15s, border-color 0.15s;
  font-family: ${({ theme }) => theme.fonts.sofia};
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: 140%; /* 19.6px */
  outline: none;
  cursor: pointer;
  @media (max-width: 768px) {
    padding: 8px 18px;
  }
`;

export const FiltersFooter = styled.footer`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
`;

export const SmallBtn = styled.button`
  background: ${(p) => (p.isSecondary ? "white" : "#307361")};
  color: ${(p) => (p.isSecondary ? "#307361" : "white")};
  border: ${(p) => (p.isSecondary ? "1px solid #307361" : "none")};
  display: flex;
  width: 273px;
  padding: 15px 32px;
  justify-content: center;
  align-items: center;
  gap: 7px;
  outline: none;
  cursor: pointer;

  font-family: ${({ theme }) => theme.fonts.sofia};
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 140%; /* 19.6px */
  @media (max-width: 768px) {
    width: 100%;
    padding: 12px 20px;
  }
`;

// Generic horizontal swiper wrappers (tags & cards)
export const HorizontalSwiper = styled.div`
  width: 100%;
  .swiper-container,
  .swiper,
  .swiper-wrapper {
    width: 100%;
  }
  .swiper-slide {
    width: auto !important; /* for tags */
  }
`;

export const CardsSwiper = styled.div`
  width: 100%;
  .swiper-slide {
    width: 220px !important;
    @media (max-width: 768px) {
      width: 180px !important;
    }
  }
`;
